var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"lazy":true,"width":"350px"},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('v-card',[_c('AgentCard',{attrs:{"userId":_vm.agentId,"userProfile":_vm.agentProfile,"tenantSubdomain":_vm.tenantSubdomain,"showCloseButton":true}})],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37ef1b7a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/AgentCardDialog.vue
// module id = qIXi
// module chunks = 1